import router from '@/router'
import tool from '@/utils/tool'

router.beforeEach((to, from, next) => {
  if (!tool.sessionGet('userType')) {
    if (to.path !== '/home' && to.path !== '/site-unavailable') {
      tool.message('请先登录')
      next({ path: '/home', query: to.query.matchId ? { matchId: to.query.matchId } : {} })
    } else {
      next()
    }
  } else {
    next()
  }
})
